module.exports = __webpack_public_path__ + "static/media/passion.062145e5.png";